import { connect } from "react-redux";

import News from "../../components/News/News";

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(News)